import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home'
import Recruit from '../views/Recruit'
import Donate from '../views/Donate'
import Classes from '../views/Classes'
import Contact from '../views/Contact'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      component: Home
    },
    {
      path: '/recruit',
      component: Recruit
    },
    {
      path: '/donate',
      component: Donate
    },
    {
      path: '/class',
      component: Classes
    },
    {
      path: '/contact',
      component: Contact
    },
    { path: '*', redirect: '/' }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js